import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'odd' })
export class OddPipe implements PipeTransform {
    transform(odd: number): string {
        if (odd == null) {
            return '';
        }
        return odd.toFixed(2);
    }
}
